import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useAuth } from '../../hooks/auth';

interface UserDocumentContextType {
  documentSelected: string | number;
  setDocumentSelected: (value: string) => void;
  nameUserSelected: string;
  setNameUserSelected: (value: string) => void;
  emailUserSelected: string;
  setEmailUserSelected: (value: string) => void;
  documents:
  | {
    id: string;
    value: string;
  }[]
  | undefined;
  handleNewDocuments(cnpj: string, documents: string[]): void;
}

interface UserDocumentContextProviderProps {
  children: ReactNode;
}

interface Documents {
  id: string;
  value: string;
}

const UserDocumentContext = createContext({} as UserDocumentContextType);

export function UserDocumentContextProvider({
  children,
}: UserDocumentContextProviderProps) {
  const { user } = useAuth();

  const [documents, setDocuments] = useState<Documents[]>();

  useEffect(() => {
    const cnpj = [{ id: user.cnpj, value: user.cnpj }];

    if (user?.documents?.length) {
      setDocuments([
        ...cnpj,
        ...user?.documents?.map((document) => ({
          id: document.document,
          value: document.document,
        })),
      ]);
    } else {
      setDocuments(cnpj);
    }
  }, [user]);

  const handleNewDocuments = (cnpj: string, documents: string[]) => {
    const cnpjFormated = [{ id: cnpj, value: cnpj }];

    if (documents?.length) {
      setDocuments([
        ...cnpjFormated,
        ...documents?.map((document) => ({
          id: document,
          value: document,
        })),
      ]);
    } else {
      setDocuments(cnpjFormated);
    }
  };

  const [documentSelected, setDocumentSelected] = useState<string>('');
  const [nameUserSelected, setNameUserSelected] = useState<string>('');
  const [emailUserSelected, setEmailUserSelected] = useState<string>('');

  const handleChangeDocument = (value: string) => {
    setDocumentSelected(value);
    localStorage.setItem("@zignetPortalEstabelecimentos:documentSelected", value);
  }

  useEffect(() => {
    const documentStorage = localStorage.getItem("@zignetPortalEstabelecimentos:documentSelected");
    setDocumentSelected(documentStorage ?? user.cnpj);
    setNameUserSelected(user.name);
    setEmailUserSelected(user.email);
  }, [user]);

  return (
    <UserDocumentContext.Provider
      value={{
        documentSelected,
        setDocumentSelected: handleChangeDocument,
        nameUserSelected,
        setNameUserSelected,
        documents,
        handleNewDocuments,
        emailUserSelected,
        setEmailUserSelected,
      }}
    >
      {children}
    </UserDocumentContext.Provider>
  );
}

const useUserDocument = () => {
  const context = useContext(UserDocumentContext);
  if (context === undefined) {
    throw new Error(
      'useUserDocument can only be used inside UserDocumentContext'
    );
  }

  return context;
};

export { UserDocumentContext, useUserDocument };
